export default "__VITE_ASSET__BCqiObsO__"